// Per-PCS + per-battery BESS fleet data (real) — for multi-PCS stations (Лучки 16×Kehua + 8×Jinko).
import { useEffect, useState } from 'react';
import { API_BASE_URL } from '@/services/api';

export interface BessUnit {
  unitId: number; pcsName: string; batteryId: number | null;
  status: string; statusRaw: number | null; flow: string; bmsStatus: string | null;
  powerKw: number | null; dcVoltageV: number | null; dcCurrentA: number | null; dcPowerKw: number | null;
  gridHz: number | null; innerTempC: number | null; radiatorTempC: number | null; availPowerKva: number | null;
  maxChargeKw: number | null; maxDischargeKw: number | null; loadRatioPct: number | null;
  pf: number | null; reactiveKvar: number | null; alarmActive: boolean;
  socPct: number | null; sohPct: number | null; batteryV: number | null; batteryA: number | null;
  totalChargeKwh: number | null; totalDischargeKwh: number | null;
  chargeAvailableKwh: number | null; dischargeAvailableKwh: number | null; quality: string | null;
}
export interface BessBattery {
  batteryId: number; pcsUnits: string[]; socPct: number | null; sohPct: number | null; packV: number | null;
  cellVmaxMv: number | null; cellVminMv: number | null; cellVspreadMv: number | null;
  tempMaxC: number | null; tempMinC: number | null;
}
export interface BessSummary {
  powerKw: number; flow: string; socPct: number | null; sohPct: number | null; gridHz: number | null; tempMaxC: number | null;
  totalChargeKwh: number; totalDischargeKwh: number; dailyChargeKwh: number; dailyDischargeKwh: number;
  chargeAvailableKwh: number; dischargeAvailableKwh: number; maxChargeKw: number; maxDischargeKw: number;
  alarmsActive: number; byStatus: Record<string, number>; online: number;
}
export interface BessFleetData {
  count: number; batteryCount: number; readAtLocal: string | null;
  summary: BessSummary; units: BessUnit[]; batteries: BessBattery[];
}

export function useBessLatest(assetId?: string, refreshMs = 30000) {
  const [data, setData] = useState<BessFleetData | null>(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    if (!assetId) { setErr(true); return; }
    let cancelled = false;
    const load = async () => {
      try {
        const r = await fetch(`${API_BASE_URL}/scada/bess/${assetId}/latest`);
        if (!r.ok) throw new Error();
        const d = await r.json();
        if (!cancelled) { setData(d); setErr(false); }
      } catch { if (!cancelled) setErr(true); }
    };
    load();
    const t = setInterval(load, refreshMs);
    return () => { cancelled = true; clearInterval(t); };
  }, [assetId, refreshMs]);
  return { data, err };
}
